import React from 'react';
import {Button, useDisclosure} from '@chakra-ui/react';
import {DeleteIntegrationModal} from './DeleteIntegrationModal';

export const DeleteIntegrationButton = ({
  warningMessage,
}: {
  warningMessage?: string;
}) => {
  const deleteIntegrationDisclosure = useDisclosure();

  return (
    <>
      <Button
        colorScheme="red"
        onClick={deleteIntegrationDisclosure.onOpen}
        variant="outline"
      >
        Delete
      </Button>
      <DeleteIntegrationModal
        isOpen={deleteIntegrationDisclosure.isOpen}
        onClose={deleteIntegrationDisclosure.onClose}
        warningMessage={warningMessage}
      />
    </>
  );
};
